// extracted by mini-css-extract-plugin
export default {"button":"button__smV7mp","logo":"logo___J1hCH"};